import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { CommerceRoot } from "./account/commerce";
import App from "./App";
import "./styles.css";
import "./components/ride-tools.css";
import "./render/render.css";
import "./render/presentation.css";
import "./components/video-export.css";
import "./components/ride-workspace-layout.css";
import "./render/legacy-plates.css";

const root = document.querySelector<HTMLDivElement>("#root");
if (root === null) {
  throw new Error("The application root element is missing.");
}

createRoot(root).render(
  <StrictMode>
    <CommerceRoot><App /></CommerceRoot>
  </StrictMode>,
);
